<template>
  <v-container fluid>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Perguntas</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.xs" lazy hide-overlay transition="dialog-bottom-transition" width="600">
            <v-btn icon color='info' slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-faq v-on:fechar="dialog = false" v-on:info="showInfo" v-on:error="showError"></cad-faq>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headersFaq"
          :items="faqs"
          :expand="expand"
          :totalItems="totalItems"
          :pagination.sync="pagination"
          :loading="loading"
          hide-actions
          item-key="id_faq"
        >
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td class="text-xs-left font-weight-bold">{{ props.item.titulo }}</td>
              <td class="text-xs-right">
                <v-icon color="teal" v-if="props.item.classificacao_posto" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-right">
                <v-icon color="teal" v-if="props.item.classificacao_frentista" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-right">
                <v-icon color="teal" v-if="props.item.classificacao_cliente" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-right">
                <v-icon color="teal" v-if="props.item.classificacao_empresa" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-right">
                <v-btn icon flat color="info" @click="editarFaq(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon  flat color="red" @click="apagarFaq(props.item)">
                  <v-icon>close</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat>
              <v-card-text v-html="props.item.conteudo"></v-card-text>
            </v-card>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog lazy :fullscreen="$vuetify.breakpoint.xs" v-model="dialogEditarFaq" width="600">
      <editar-faq v-on:fechar="dialogEditarFaq = false" v-on:info="showInfo" v-on:error="showError"></editar-faq>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
  </v-snackbar>
  </v-container>
</template>

<script>

import CadFaq from '@/components/cadastros/CadFaq'
import EditarFaq from '@/components/dialogs/DialogEditarFaq'
import SmartLockMessage from '@/components/SmartLockMessage'
import { faqDao } from '@/api'

export default {
  components: { CadFaq, EditarFaq, SmartLockMessage },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogEditarFaq: false,
      expand: false,
      pagination: {},
      dialog: false,
      headersFaq: [
        {
          text: 'Título',
          sortable: false,
          align: 'left',
          value: 'titulo'
        },
        {
          text: 'Posto',
          sortable: false,
          align: 'right'
        },
        {
          text: 'Frentista',
          sortable: false,
          align: 'right'
        },
        {
          text: 'Cliente',
          sortable: false,
          align: 'right'
        },
        {
          text: 'Empresa',
          sortable: false,
          align: 'right'
        },
        {
          text: '',
          sortable: false,
          align: 'right'
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    totalItems () {
      return this.$store.getters.totalItemsFaqs
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    faqs () {
      return this.$store.getters.faqs
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  watch: {
    pagination: {
      handler () {
        this.$store.dispatch('carregarFaqs', this.pagination)
      },
      deep: true
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('carregarFaqs', this.pagination)
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('carregarFaqs', this.pagination)
    }
  },
  methods: {
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
      this.$store.dispatch('carregarFaqs', this.pagination)
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    editarFaq (faq) {
      this.$store.dispatch('selectFaq', faq)
      this.dialogEditarFaq = true
    },
    apagarFaq (faq) {
      faqDao.deleteFaq(faq.id_faq, this.headers)
        .then(response => {
          if (response.ok) {
            this.showInfo('Pergunta excluída com sucesso')
            this.$store.dispatch('carregarFaqs', this.pagination)
          } else {
            this.showError('A pergunta não pôde ser excluída')
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
